export default {
  title: 'Salgsteamets rapport',
  fields: {
    name: 'Navn',
    area: 'Område',
    signed: 'Underskrevet',
    live: 'Live',
  },
  buttons: {
    download_report: 'Download rapport',
  },
  toasts: {
    failed_to_load_data: 'Kunne ikke indlæse data. Opdater siden',
  },
};
